module.exports = __webpack_public_path__ + "images/d063549ce36dd3a9acffc2e986be34db429699c83f39f33bd779e74cb4a7e131.svg";